import {
  GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_ABORTED,
  GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED,
  GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED,
  GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED,
  SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED,
  SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED,
  SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED,
} from '../../actions/clientwithdrawalsallow/types';

const schema = {
  error: null,
  data: { items: [] },
  rule: { items: [] },
  gettingdata: false,
  gotdata: false,
};

export const initialState = { ...schema };

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_ABORTED:
      return {
        ...state,
        error: null,
        gettingdata: false,
      };

    case GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED:
      return {
        ...state,
        error: null,
        data: { items: [] },
        gettingdata: true,
      };

    case GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED:
      return {
        ...state,
        error: null,
        data: action.payload,
        gettingdata: false,
      };

    case GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED:
      return {
        ...state,
        error: action.payload,
        gettingdata: false,
      };

    case SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED:
      return {
        ...state,
        error: action.payload,
        gettingdata: false,
      };

    case SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED:
      return {
        ...state,
        error: null,
        data: { items: [] },
        gettingdata: true,
      };

    case SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED:
      return {
        ...state,
        error: null,
        data: action.payload,
        gettingdata: false,
      };

    default:
      return state;
  }
};

export default reducer;
